import { LocalizationProvider } from "@mui/x-date-pickers";
import { ptBR } from "date-fns/locale";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
  Router,
  Routes,
  Route,
  Navigate,
  useLocation,
  useMatch,
} from "react-router-dom";

// import MainLayout from "./components/layout/MainLayout";
// import MainPage from "./pages/main/MainPage";
import LoginPage from "./pages/login/LoginPage";
import MainLayout from "./components/layout/MainLayout";
import MainPage from "./pages/main/mainPage";
import { Alunos } from "./pages/cadastros/Alunos";
import { Eventos } from "./pages/cadastros/Eventos";
import { Turmas } from "./pages/cadastros/Turmas";
import { Cobranca } from "./pages/cobranca/Cobranca";
import { Disciplinas } from "./pages/cadastros/Disciplinas";
import { FinanceiroAlunos } from "./pages/financeiro/FinanceiroAlunos";

function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route element={<MainLayout />}>
          <Route path="/main" element={<MainPage />} />
          <Route path="/cadastros/alunos" element={<Alunos />} />
          <Route path="/cadastros/eventos" element={<Eventos />} />
          <Route path="/cadastros/turmas" element={<Turmas />} />
          <Route path="/cadastros/disciplinas" element={<Disciplinas />} />
          <Route path="/cobranca" element={<Cobranca />} />
          <Route path="/financeiro/alunos" element={<FinanceiroAlunos />} />
        </Route>
      </Routes>
    </LocalizationProvider>
  );
}

export default App;
